import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

export const apiFetchPredesTransactionsReject = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'rejectPredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    comment: payload.params.comment,
    transactionIds: payload.params.transactionIds,
  });
};

export const apiFetchPredesTransactionsBulkReject = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'rejectPredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    transactionIds: payload.params.transactionIds,
  });
};
